import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';
import cellEditFactory from 'react-bootstrap-table2-editor';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import 'react-sliding-side-panel/lib/index.css';
import noMessageIcon from '../../assets/Images/no-active-tray.png';
import processChart from '../../assets/Images/processChart.svg';
import ReorderProcess from '../../assets/Images/reorderProcess.svg';
import { DateFormatForDatePickerJP } from '../../constants/date-picker-constant';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  ActiveTrayDefaultSortColumnOrder,
  ActiveTrayFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import { IActiveTrayFilter } from '../../models/IActiveTrayFilter';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import {
  IActiveProcesses,
  IActiveTrayProcessDue,
} from '../../models/response/IActiveTrayResponse';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import RoutesConstants from '../../shared-components/routes/routes-constants';
import {
  CloseSidePanelIcon,
  DeleteIcon,
  RefreshIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import ActiveTrayDetails from './active-tray-details';
import './active-tray-management.css';
import AddEditActiveTrayManagement from './components/add-edit-active-tray-management';
import EditActiveTrayDate from './components/edit-active-tray-date';
import FilterComponent from './components/filter';
import ImportActiveTrayDetails from './components/import-active-tray-details';
import ProcessReorder from './components/process-reorder';
import AddEditActiveTrayManagementPopupHOC from './hoc/add-edit-active-tray-management-popup-hoc';
import EditActiveTrayDatePopupHOC from './hoc/edit-active-tray-date-popup-hoc ';
import ImportActiveTrayDetailsPopupHOC from './hoc/import-active-tray-details-popup-hoc';
import ReorderProcessPopupHOC from './hoc/reorder-process-popup-hoc';
import { fi } from 'date-fns/locale';
import ProcessDueDateChangePopupHOC from './hoc/process-due-date-change-popup-hoc';

const ActiveTrayManagement = (props: any) => {
  const location = useLocation<any>();
  const {
    preferencesStore,
    trayManagementStore,
    activeTrayManagementStore,
    processStore,
  } = useStore();
  const {
    deleteTrayState,
    DeleteTrayService,
    resetDeleteTray,
    resetTrayDetail,
    addUpdateTrayState,
    resetAddUpdateTrayState,
    fileUploadState,
    resetFileUploadState,
    duplicateData,
    trayState,
  } = trayManagementStore;

  const { checkedColumns, setCheckedColumns } = processStore;
  const [selectedRowTrayId, setSelectedRowTrayId] = useState('');

  const {
    GetActiveTrayListService,
    getActiveTrayListServiceState,
    allActiveTrays,
    activeTrayList,
    activeTrayState,
    allProcessHeaders,
    UpdateProcessDueDatetService,
    getUpdateProcessDueDatetState,
    resetGetUpdateProcessDueDatetState,
    allProcessHeadersSequence,
    saveProcessOrderState,
    resetSaveProcessOrderState,
    updateProcessDueDateWithFilterState,
    resetUpdateProcessDueDateWithFilterState,
  } = activeTrayManagementStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  // const {allProcessReactSelectOptions} = processStore;

  let lang: string;
  const allTrayListData = allActiveTrays;
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    ActiveTrayDefaultSortColumnOrder
  );
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [selectedProcessId, setSelectedProcessId] = useState(-1);
  const [selectedProcessName, setSelectedProcessName] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [customerDueDate, setCustomerDueDate] = useState('');
  const [openPanel, setOpenPanel] = useState(false);
  const pageLimitOptions: Array<number> = [50, 100, 500, 1000];
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [filterObj, setFilterObj] = useState<IActiveTrayFilter>(
    ActiveTrayFilterInitialState
  );
  const skipInitialLoad = useRef(
    Boolean(
      location.state || localStorage.getItem('active_tray_selected_chart_data')
    )
  );

  const [selectedCheckedTrayId, setSelectedcheckedTrayId] = useState<any>([]);

  const [isEditing, setIsEditing] = useState(false);
  const [processOrder, setProcessOrder] = useState('');
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getActiveTrayListServiceHandler = (
    filterQuery?: string,
    order = '',
    isFilter = false
  ) => {
    const processOrderingDetails =
      localStorage.getItem('process_order') ||
      order ||
      allProcessHeadersSequence;

    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      });
    }

    // if (processOrderingDetails) {
    //   setProcessOrder(processOrderingDetails);
    // }
    if (!isFilter) {
      GetActiveTrayListService(
        Number(getTenantIdFromLocalStorage()),
        pageLimitInfo.pageLimit,
        pageInfo.currentPage,
        encodeURIComponent(filterQuery)
        // processOrderingDetails
      );
    } else {
      GetActiveTrayListService(
        Number(getTenantIdFromLocalStorage()),
        pageLimitInfo.pageLimit,
        1,
        encodeURIComponent(filterQuery)
        // processOrderingDetails
      );
    }
  };

  const handleProcessReorderSubmit = () => {
    // setTimeout(() => {
    // }, 5000);
  };

  const getddMMyyDateFormat = (input: string): string => {
    const date = new Date(input);

    return (
      String(date.getDate()).padStart(2, '0') +
      String(date.getMonth() + 1).padStart(2, '0') +
      String(date.getFullYear()).slice(-2)
    );
  };

  const selectRowLeft = {
    mode: 'checkbox',
    clickToEdit: false,
    selectionRenderer: ({ mode, checked, disabled }: any) => (
      <input
        type={mode}
        checked={checked}
        disabled={disabled}
        className="form-check-input"
        readOnly
      />
    ),
    selectionHeaderRenderer: ({ checked, indeterminate }: any) => (
      <input
        type="checkbox"
        checked={checked}
        ref={(input: HTMLInputElement | null) => {
          if (input) input.indeterminate = indeterminate;
        }}
        className="form-check-input"
        readOnly
      />
    ),
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedcheckedTrayId((prev) => [...prev, row.Id]);
      } else {
        setSelectedcheckedTrayId((prev) => prev.filter((id) => id !== row.Id));
      }
    },
    selected: selectedCheckedTrayId,
  };

  const cellEdit = cellEditFactory({
    mode: 'click',
    blurToSave: false,
    onStartEdit: (row, column, rowIndex, columnIndex, e) => {
      e?.stopPropagation?.();
    },
    beforeSaveCell(oldValue, newValue, row, column, done) {
      setTimeout(() => {
        if (selectedCheckedTrayId.length === 0) {
          selectedCheckedTrayId.push(row.Id);
        }
        // if (confirm('Do you want to accept this change?')) {
        UpdateProcessDueDatetService(
          selectedCheckedTrayId.join(','),
          Number(getTenantIdFromLocalStorage()),
          oldValue.split('_')[1],
          getddMMyyDateFormat(newValue)
        );
        done(); // contine to save the changes
        // } else {
        // done(false); // reject the changes
        // }
      }, 0);
      return { async: true };
    },
    afterSaveCell: () => setIsEditing(false),
    // onStartEdit: () => setIsEditing(false),
  });

  useEffect(() => {
    const handleProcessChartData = (chartData: any) => {
      if (!chartData?.date || !chartData?.processName) return;

      const chartFilter = {
        ...ActiveTrayFilterInitialState,
        ProcessDueDate: chartData.date,
        ProcessName: chartData.processName,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      };

      setFilterObj(chartFilter);
      setIsFilterApplied(true);
      setIsFilterCleared(false);
      setPageInfo((currentPageInfo) => ({
        ...currentPageInfo,
        currentPage: 1,
      }));
      getActiveTrayListServiceHandler(createQueryString(chartFilter), '', true);
    };

    // 1. Check location.state from router navigation
    if (location.state) {
      handleProcessChartData(location.state);
      localStorage.removeItem('active_tray_selected_chart_data');
    } else {
      // 2. Check localStorage fallback
      const stored = localStorage.getItem('active_tray_selected_chart_data');
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          handleProcessChartData(parsed);
          localStorage.removeItem('active_tray_selected_chart_data');
        } catch (err) {
          console.error('Error parsing active_tray_selected_chart_data:', err);
        }
      }
    }

    // 3. Listen for postMessage from popup/opener window
    const messageListener = (event: MessageEvent) => {
      if (event.data?.type === 'PROCESS_CHART_CELL_CLICK' && event.data?.data) {
        handleProcessChartData(event.data.data);
      }
    };
    window.addEventListener('message', messageListener);

    // 4. Listen for BroadcastChannel messages
    let channel: BroadcastChannel | null = null;
    try {
      channel = new BroadcastChannel('active_tray_channel');
      channel.onmessage = (event) => {
        if (event.data?.type === 'PROCESS_CHART_CELL_CLICK' && event.data?.data) {
          handleProcessChartData(event.data.data);
        }
      };
    } catch (e) {
      console.error('BroadcastChannel error:', e);
    }

    // 5. Listen for storage events (fired when localStorage is set in another tab)
    const storageListener = (event: StorageEvent) => {
      if (event.key === 'active_tray_selected_chart_data' && event.newValue) {
        try {
          const parsed = JSON.parse(event.newValue);
          handleProcessChartData(parsed);
          localStorage.removeItem('active_tray_selected_chart_data');
        } catch (e) {
          console.error('Error parsing storage event data:', e);
        }
      }
    };
    window.addEventListener('storage', storageListener);

    return () => {
      window.removeEventListener('message', messageListener);
      window.removeEventListener('storage', storageListener);
      if (channel) channel.close();
    };
  }, [location.state]);

  useEffect(() => {
    if (!skipInitialLoad.current) {
      getActiveTrayListServiceHandler();
    }
    return () => {
      setCheckedColumns([]);
    };
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: activeTrayList?.PagingDetails?.TotalPages,
      currentPage: activeTrayList?.PagingDetails?.CurrentPage,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [activeTrayList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getActiveTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getActiveTrayListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getActiveTrayListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (fileUploadState.success) {
      toast.success(formatMessage('added_success'));
      resetFileUploadState();
      getActiveTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileUploadState.success]);

  useEffect(() => {
    if (addUpdateTrayState.success) {
      resetAddUpdateTrayState();
      getActiveTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateTrayState.success]);

  useEffect(() => {
    if (deleteTrayState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteTray();
      getActiveTrayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteTrayState.success]);

  useEffect(() => {
    if (getUpdateProcessDueDatetState.success) {
      resetGetUpdateProcessDueDatetState();
      getActiveTrayListServiceHandler();
      setSelectedcheckedTrayId([]);
    }
  }, [getUpdateProcessDueDatetState.success]);

  useEffect(() => {
    if (updateProcessDueDateWithFilterState.success) {
      resetUpdateProcessDueDateWithFilterState();
      getActiveTrayListServiceHandler();
    }
  }, [updateProcessDueDateWithFilterState.success]);

  // useEffect(() => {
  //   if (processOrder) {
  //     getActiveTrayListServiceHandler(
  //       createQueryString(filterObj),
  //       processOrder
  //     );
  //   }
  // }, [processOrder]);

  useEffect(() => {
    if (saveProcessOrderState.success) {
      toast.success(formatMessage('updated_success'));
      getActiveTrayListServiceHandler(createQueryString(filterObj));
      resetSaveProcessOrderState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveProcessOrderState.success]);

  useEffect(() => {
    if (getUpdateProcessDueDatetState.success) {
      toast.success(formatMessage('updated_success'));
    }
  }, [getUpdateProcessDueDatetState.success]);

  useEffect(() => {
    if (getUpdateProcessDueDatetState.error) {
      toast.error(formatMessage(getUpdateProcessDueDatetState.error));
      resetGetUpdateProcessDueDatetState();
    }
  }, [getUpdateProcessDueDatetState.error]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    // GetProcessByIdService(row.Id);
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    const filter = createQueryString({ ...filterObj });
    getActiveTrayListServiceHandler(filter);
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteTrayService(Number(getTenantIdFromLocalStorage()), selectedId);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedRowTrayId(row.TrayId);
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetTrayDetail();
    props.deletePopupToggleHandler();
  };

  const createQueryString = (filter: IActiveTrayFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: IActiveTrayFilter) => {
    const filter = createQueryString({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    getActiveTrayListServiceHandler(filter, '', true);
    setFilterObj({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
    // resetGetFactoryDetail();
  };

  const filterParams = (obj: IActiveTrayFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      getActiveTrayListServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  const checkTodaysDate = (dateString) => {
    const [year, month, day] = dateString.split('-');
    const formattedDate = `${year}-${month}-${day}`; // Convert to YYYY-MM-DD

    const inputDate = new Date(formattedDate);
    const today = new Date();

    // Reset time for an accurate date-only comparison
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return inputDate.getTime() === today.getTime();
  };

  const checkAlreadyPassedDateStatus = (targetDate) => {
    const [year, month, day] = targetDate.split('-');

    const formattedDate = `${year}-${month}-${day}`; // Convert to YYYY-MM-DD

    const target = new Date(formattedDate);
    const today = new Date();

    // Reset time to avoid issues with time comparison
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);
    return target < today;
    // if (target < today)
    //   return "The date has already passed.";
    // } else if (target.getTime() === today.getTime()) {
    //   return "The date is today!";
    // } else {
    //   const diffDays = Math.ceil((target - today) / (1000 * 60 * 60 * 24));
    //   return `The date is ${diffDays} days away.`;
    // }
  };

  function dateFormatterMMdd(dateString: string) {
    // Parse the date string
    const [year, month, day] = dateString.split('-');
    const date = new Date(`${year}-${month}-${day}`);

    // Format the date using inbuilt methods
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
    });
  }

  // const checkedColumnsMap = useMemo(() => {
  //   return new Map(checkedColumns.map((col) => col));
  // }, [checkedColumns]);

  const processColumns = allProcessHeaders.map(
    (process: IActiveTrayProcessDue, index: number) => {
      const processShortName = process.ProcessShortName;
      const processId = process.ProcessId;

      // O(1) Lookup
      return {
        dataField: processId,
        text: formatMessage(processShortName),
        hidden: process?.IsHidden || false,
        editable:
          processId >= 0 || processId === -2
            ? (cell: string) =>
                cell !== 'done' && cell !== 'N/A' && cell !== '-'
            : false,

        headerFormatter: (column: { text: string }) => (
          <span
            title={process.ProcessName}
            style={{
              border: 'none',
              fontWeight: 'bold',
              textAlign: 'center',
              padding: '5px',
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedProcessId(processId);
              setSelectedProcessName(process.ProcessName);
              props.processDueDateChangeToggleHandler();
            }}
          >
            {column.text}
          </span>
        ),

        editorRenderer: (editorProps: any, value: string, row: any) => {
          const datePart = value?.split('_')[0];
          return (
            <DatePicker
              autoFocus
              className="form-control"
              dateFormat={DateFormatForDatePickerJP}
              locale={language}
              selected={datePart ? new Date(datePart) : null}
              onChange={(date) => {
                editorProps.onUpdate(
                  date ? date.toISOString().split('T')[0] : ''
                );
              }}
              onBlur={editorProps.onBlur}
              maxDate={row.CustomerDueDate}
              minDate={new Date()}
            />
          );
        },

        events: {
          onClick: (e: any, column: any, columnIndex: number, row: any) => {
            e.stopPropagation();
            const cellValue = row?.[processShortName];

            if (cellValue && cellValue !== 'N/A' && cellValue !== 'done') {
              const [, param1, param2] = cellValue.split('_');
              setCustomerDueDate(row.CustomerDueDate);
              handleDateChange(e, param1, param2);
            }
          },
        },

        formatter: function (cell: string) {
          if (!cell || cell === 'N/A') {
            return '-';
          }

          if (cell === 'done') {
            return (
              <span className="null-class badge">{formatMessage('Done')}</span>
            );
          }

          // Handle Date-string formatted cells ("YYYY-MM-DD_some_id")
          const dateString = cell.split('_')[0];
          let highlightClass = 'normal-class';

          if (dateString) {
            if (checkTodaysDate(dateString)) {
              highlightClass = 'today-class badge';
            } else if (checkAlreadyPassedDateStatus(dateString)) {
              highlightClass = 'date-passed-class badge';
            }
          }

          return (
            <span
              onClick={(e) => e.preventDefault()}
              className={highlightClass}
            >
              {dateFormatterMMdd(dateString)}
            </span>
          );
        },
      };
    }
  );

  const handleDateChange = (e, orderProcessId, dueDate) => {
    setSelectedProcessId(orderProcessId);
    setSelectedDate(new Date(dueDate));
    // props.addActiveTrayDateToggleHandler();
  };

  const handleProcessReorderToggleHandler = (e) => {
    props.processReorderToggleHandler();
    // getActiveTrayListServiceHandler(createQueryString(filterObj));
  };

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        isDisable: !isOperationPermittedRoleBase(
          ModuleType.TrayManagement,
          'Delete'
        ),
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
    ],
    ModuleType.TrayManagement
  );

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
      editable: false,
    },

    {
      dataField: 'Kishu',
      text: formatMessage('kishu'),
      classes: 'show-Elipses',
      sort: true,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      formatter: (cell, row, rowIndex, columnIndex) => (
        <span
          onClick={(e) => {
            if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
              setOpenPanel(true);
            } else {
              setOpenPanel(!openPanel);
            }
          }}
        >
          {cell}
        </span>
      ),
      editable: false,
    },
    {
      dataField: 'EndUserName',
      text: formatMessage('end_user_name_short'),
      classes: 'show-Elipses',
      sort: true,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      formatter: (cell, row, rowIndex, columnIndex) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
      editable: false,
    },
    {
      dataField: 'EndUserOrderId',
      text: formatMessage('end_user_order_id_short'),
      classes: 'show-Elipses',
      sort: true,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      formatter: (cell, row, rowIndex, columnIndex) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
      editable: false,
    },
    {
      dataField: 'PlanedDueDate',
      text: formatMessage('planned_due_dates'),
      classes: 'show-Elipses',
      sort: true,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      editable: false,
      formatter: (cell, row, rowIndex, columnIndex) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
      hidden: true,
    },
    {
      dataField: 'OrderId',
      text: formatMessage('order_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      editable: false,
      formatter: (cell, row, rowIndex, columnIndex) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
    },
    {
      dataField: 'TrayId',
      text: formatMessage('tray_id'),
      editable: false,
      sort: true,
      formatter: (cell, row, rowIndex) => (
        <div
          className="d-flex align-items-center"
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          <span>{cell}</span>
          {row.AbnormalityRemark && row.AbnormalityRemark.length > 0 && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id={`tray-tooltip-${rowIndex}`}>
                  {row.AbnormalityRemark}
                </Tooltip>
              }
            >
              <span className="info-svg">
                <InfoCircle size={14} />
              </span>
            </OverlayTrigger>
          )}
        </div>
      ),
      // classes: 'show-Elipses sticky-column',
      // headerClasses: 'sticky-header',
    },
    {
      dataField: 'SubContractor',
      text: formatMessage('sub_contractor'),
      classes: 'show-Elipses',
      editable: false,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'Quantity',
      text: formatMessage('quantity_short'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      editable: false,
      formatter: (cell) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
    },
    {
      dataField: 'ProductComment1',
      text: formatMessage('product_comment_1'),
      classes: 'show-Elipses',
      sort: false,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      editable: false,
      formatter: (cell) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
      hidden: false,
    },
    {
      dataField: 'ProductComment2',
      text: formatMessage('product_comment_2'),
      classes: 'show-Elipses',
      sort: false,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      editable: false,
      formatter: (cell) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
      hidden: false,
    },
    {
      dataField: 'ProductComment3',
      text: formatMessage('product_comment_3'),
      classes: 'show-Elipses',
      sort: false,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      editable: false,
      formatter: (cell) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
      hidden: false,
    },
    {
      dataField: 'ProductComment4',
      text: formatMessage('product_comment_4'),
      classes: 'show-Elipses',
      sort: false,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      editable: false,
      formatter: (cell) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
      hidden: false,
    },
    {
      dataField: 'ProductComment5',
      text: formatMessage('product_comment_5'),
      classes: 'show-Elipses',
      sort: false,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      editable: false,
      formatter: (cell) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
      hidden: false,
    },
    {
      dataField: 'ProductComment6',
      text: formatMessage('product_comment_6'),
      classes: 'show-Elipses',
      sort: false,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      editable: false,
      formatter: (cell) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
      hidden: false,
    },
    {
      dataField: 'MissingParts',
      text: formatMessage('missing_parts'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      editable: false,
      formatter: (cell, row, rowIndex, columnIndex) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
    },
    {
      dataField: 'CustomerDueDate',
      text: formatMessage('customer_due_date'),
      classes: 'show-Elipses',
      sort: true,
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      formatter: (cell, row, rowIndex, columnIndex) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
      editable: false,
    },
    ...processColumns,
    {
      dataField: 'Remarks',
      text: formatMessage('comment'),
      classes: 'show-Elipses',
      // title: (cell: string) => {
      //   // return cell.length > 10 ? cell : undefined;
      // },
      editable: false,
      formatter: (cell, row, rowIndex, columnIndex) => (
        <span
          onClick={(e) => {
            setOpenPanel((prev) => !prev);
          }}
        >
          {cell}
        </span>
      ),
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
      editable: false,
    },

    // {
    //   dataField: '',
    //   formatter: CustomActionFormatter(actionIcons),
    //   text: formatMessage('actions'),
    //   classes: 'last-column',
    //   hidden: actionIcons.length > 0 ? false : true,
    // },
  ];

  const handleTableChange = (type: any, newState: any) => {
    setColumnSortOrder({
      ...columSortOrder,
      dataField: newState.sortField,
      order: newState.sortOrder,
    });
    const filter = createQueryString({
      ...filterObj,
      Column: newState.sortField,
      Order: newState.sortOrder,
    });

    getActiveTrayListServiceHandler(filter);
  };

  return (
    <>
      {props.showImportPopup && (
        <ImportActiveTrayDetails
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}

      {props.showAddTrayManagementPopup && (
        <AddEditActiveTrayManagement
          id={selectedId}
          modalClosed={props.addTrayToggleHandler}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_tray"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_tray_confirm"
          isLoading={deleteTrayState.inProgress}
          id={selectedRowTrayId}
        />
      )}
      {props.showReorderProcessPopup && (
        <ProcessReorder
          id={selectedId}
          modalClosed={props.processReorderToggleHandler}
          processOptions={[]}
          onSubmitReorder={handleProcessReorderSubmit}
        />
      )}
      {props.showProcessDueDateChangePopup && (
        <EditActiveTrayDate
          id={selectedId}
          modalClosed={props.processDueDateChangeToggleHandler}
          orderProcessId={selectedProcessId}
          selectedDate={selectedDate}
          customerDueDate={customerDueDate}
          filter={filterObj}
          selectedProcessName={selectedProcessName}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col-lg-5 col-md-6 col-sm-6"
            label="active_tray_management"
          />

          <div className="col-lg-7 col-md-6 col-sm-6">
            <ul className="add-list">
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isLoading={false}
                  isDisable={false}
                  isFilterCleared={isFilterCleared}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                />
              </li>
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              <li
                title={formatMessage('reorder_process')}
                className=""
              >
                <a
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-testid="modalbtn"
                  data-target="#addUser"
                  onClick={handleProcessReorderToggleHandler}
                >
                  {' '}
                  <img
                    src={ReorderProcess}
                    alt=""
                    className="ReorderProcess me-1"
                  />
                  <FormattedMessage id="reorder_process" />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.ActiveTrayManagement,
                'Add'
              ) && (
                <li
                  title={formatMessage('process_wise_chart')}
                  className="process-chart"
                >
                  <a
                    className="btn btn-secondary"
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) => {
                      event.preventDefault();
                      window.open(
                        RoutesConstants.ProcessWiseChart,
                        '_blank',
                        'noopener,noreferrer'
                      );
                    }}
                  >
                    <img
                      src={processChart}
                      alt=""
                      className="processChart me-1"
                    />
                    <FormattedMessage id="process_wise_chart" />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getActiveTrayListServiceState.inProgress ||
            activeTrayState.inProgress ||
            deleteTrayState.inProgress ||
            addUpdateTrayState.inProgress ||
            trayState.inProgress) && (
            <FormLoader
              loading={
                getActiveTrayListServiceState.inProgress ||
                activeTrayState.inProgress ||
                deleteTrayState.inProgress ||
                addUpdateTrayState.inProgress ||
                trayState.inProgress ||
                saveProcessOrderState.inProgress
              }
            />
          )}
          {allTrayListData && allTrayListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel tray-mangement">
                  <div
                    className="table-responsive tray-management-table table-first-column-fixed"
                    data-testid="table"
                  >
                    {allTrayListData && (
                      <Grid
                        data={allTrayListData}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        selectRow={selectRowLeft}
                        hover={true}
                        sort={{ ...columSortOrder }}
                        remote={{ sort: true }}
                        onTableChange={handleTableChange}
                        cellEdit={cellEdit}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allTrayListData.length > 0 ? (
                <div className="row no-gutters p-3 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={activeTrayList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_active_tray" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_active_tray_message')}
                  </h4>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
        backdropClicked={() => setOpenPanel(false)}
      >
        <div className="bg_slide panel ">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.TrayId}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper tray-detail pb-3">
            <ActiveTrayDetails selectedRowId={selectedRow.Id} />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default ProcessDueDateChangePopupHOC(
  ReorderProcessPopupHOC(
    EditActiveTrayDatePopupHOC(
      ImportActiveTrayDetailsPopupHOC(
        FilterPopupHOC(
          AddEditActiveTrayManagementPopupHOC(
            DeletePopupHOC(observer(ActiveTrayManagement))
          )
        )
      )
    )
  )
);
